import React from "react";
import { EntityFieldMetaDataContextInterface } from "module/entity/context/fieldMetaData/EntityFieldMetaDataContext";

export type InventoryCheckArticleFieldMetaDataContextInterface =
  EntityFieldMetaDataContextInterface;

const InventoryCheckArticleFieldMetaDataContext = React.createContext(
  <InventoryCheckArticleFieldMetaDataContextInterface>{}
);

export default InventoryCheckArticleFieldMetaDataContext;
